export default __webpack_public_path__ + "img/UnpaidBuilding.93a1b4f5.svg";